module.exports = __webpack_public_path__ + "static/space-9e2e843ddfdec0f0fff02ac8afc3195c.jpg";